'use strict';

const { extend, omit } = require('underscore');

const BaseView = require('./base');

class CollectionView extends BaseView {
  constructor() {
    super(...arguments);

    if (this.collection) {
      this.collection.on('add', model => this.appendChildView(model));
      this.collection.on('remove', model => this.removeChildView(model));
      this.collection.on('reset', this.render, this);
      this.collection.on('sort', this.render, this);
    }
  }

  container() {
    const container = this.$el.find('[yield]');
    if (container.length) {
      return container;
    } else {
      return this.$el;
    }
  }

  render() {
    super.render(...arguments);

    if (this.collection) {
      const { models } = this.collection;
      const limit = this.options.limit && models.length > this.options.limit ? this.options.limit : models.length;
      let i = 0;
      while (i < limit) {
        this.appendChildView(models[i]);
        i++;
      }
    }

    return this;
  }

  appendChildView(model) {
    this.renderChildView('append', model);
  }

  prependChildView(model) {
    this.renderChildView('prepend', model);
  }

  renderChildView(insert, model) {
    const options = {
      model,
      id: model ? model.id : undefined,
    };

    const childView = new this.childView(extend(options, omit(this.options, 'el')));
    childView.on('all', this.bubbleUpEvent, this);
    this.container()[insert](childView.render().el);
    return this;
  }

  removeChildView(model) {
    this.container()
      .find(`#${model.id}`)
      .remove();
  }

  bubbleUpEvent() {
    this.trigger.apply(this, arguments);
  }
}

module.exports = CollectionView;
